import { render } from "./KnowSection.vue?vue&type=template&id=af5a2844&scoped=true"
const script = {}

import "./KnowSection.vue?vue&type=style&index=0&id=af5a2844&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-af5a2844"]])

export default __exports__